import React from 'react';
import { formatCurrency } from '../../../utils/assessmentResults/formatters';

/**
 * Roadmap Tab Component
 */
export const RoadmapTab = ({ recommendations = [] }) => {
  const safeRecommendations = recommendations || [];
  
  if (safeRecommendations.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Implementation Roadmap</h3>
        <p className="text-gray-600 dark:text-gray-400">No recommendations available yet. Recommendations will appear here once the assessment analysis is complete.</p>
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-gray-200 dark:border-gray-700">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Implementation Roadmap</h3>
        <div className="space-y-4">
          {safeRecommendations.slice(0, 5).map((rec, index) => (
          <div key={index} className="flex items-start space-x-4 p-4 bg-gray-50 dark:bg-gray-900 rounded-lg">
            <div className="flex-shrink-0 w-8 h-8 bg-emerald-500 text-white rounded-full flex items-center justify-center font-bold">
              {index + 1}
            </div>
            <div className="flex-grow">
              <h4 className="font-semibold text-gray-900 dark:text-white">{rec.title}</h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{rec.description}</p>
              <div className="flex items-center space-x-4 mt-2 text-xs text-gray-500 dark:text-gray-400">
                <span>Payback: {(rec.payback_years || 1.5).toFixed(1)} years</span>
                <span>Savings: {formatCurrency(rec.annual_savings || 15000)}/year</span>
                <span>Phase: {rec.cost_category === 'low_cost' ? 'Quick Wins' : rec.cost_category === 'medium_cost' ? 'Phase 2' : 'Strategic'}</span>
              </div>
            </div>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
};

